module.exports = __webpack_public_path__ + "8e6d128157b29bd60360b876f0c2ee67.jpg";